<template>
  <div>
    <el-select
      v-model="selected"
      :multiple="params.multiple"
      :value-key="params.key"
      filterable
      clearable
      style="width: 100%"
    >
      <el-option
        v-for="(option, optionName, index) in data"
        :key="index"
        :label="option[params.label]"
        :value="option"
        :readonly="true"
      />
    </el-select>
    <el-table :data="dataTable" :max-height="height">
      <el-table-column
        v-for="(column, index) in columns"
        :key="index"
        :label="column.label"
        :prop="column.prop"
        :width="column.width"
      >
        <template slot-scope="scope">
          <TableColumn :column="column" :row="scope.row" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import TableColumn from "@/components/TableColumn";

export default {
  components: {
    TableColumn,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
    value: {
      type: [Array, String, Number],
      required: false,
      default() {
        const { multiple } = this.params;
        if (multiple) {
          return [];
        }
        return null;
      },
    },
    height: {
      type: Number,
      required: false,
      default: 464,
    },
    columns: {
      type: Array,
      required: true,
    },
    typeId: {
      type: String,
      required: false,
      default: "id",
    },
    func: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      dataTable: [],
    };
  },
  computed: {
    selected: {
      get() {
        if (Array.isArray(this.value) && Number(this.value[0])) {
          return this.value.map((e) =>
            this.data.find((item) => item[this.params.key] === e)
          );
        }
        if (typeof this.value !== "object") {
          return this.data.find((item) => item[this.params.key] === this.value);
        }
        return Array.isArray(this.value) ? this.value[0] : this.value;
      },
      async set(val) {
        const data = await this.func(val);
        this.dataTable = [data];
        this.$emit("input", [val[this.params.key], this.dataTable]);
      },
    },
    normalizeDataTable() {
      return this.data.map((column) => {
        // this.value.forEach((value) => {
        //   // if (column[this.typeId] === value[this.typeId]) {
        //   //   column[this.select.columnKey] = value[this.select.columnKey];
        //   // }
        // });
        return column;
      });
    },
  },
  watch: {
    async value(val) {
      console.log(val);
      if (val) {
        const data = await this.func(val);
        this.dataTable = [data];
      }
    },
  },
  methods: {
    onFilter(value, row) {
      return row[this.select.columnKey] === value;
    },
  },
};
</script>
